var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": '마이페이지'
    }
  }), _c('mypage-navigation'), _vm.me ? _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('tit-primary', {
    attrs: {
      "sc": "edit profile",
      "tit": "회원정보수정"
    }
  }), _c('div', {
    staticClass: "text-right color-grey page-text--sm mb-20 line-height-1"
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("*")]), _vm._v("필수 입력항목")]), _c('div', {
    staticClass: "board-table board-table--input",
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('input-row', {
    attrs: {
      "label": "아이디"
    }
  }, [_vm._v(" " + _vm._s(_vm.me.username) + " ")]), _c('myinfo-usertype', {
    model: {
      value: _vm.me,
      callback: function callback($$v) {
        _vm.me = $$v;
      },
      expression: "me"
    }
  }), _c('input-row', {
    attrs: {
      "label": "비밀번호",
      "pointer": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "name": "",
      "value": "",
      "outlined": "",
      "hide-details": "",
      "placeholder": "비밀번호를 입력하세요."
    },
    model: {
      value: _vm.me.subPassword,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "subPassword", $$v);
      },
      expression: "me.subPassword"
    }
  }), _c('p', {
    staticClass: "d-block text-grey mt-4 font-size-10 font-size-lg-12"
  }, [_vm._v("* (영문대소문자/숫자/특수문자 조합, 8 - 16자)")])], 1), _c('input-row', {
    attrs: {
      "label": "비밀번호 확인",
      "pointer": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "name": "",
      "value": "",
      "outlined": "",
      "hide-details": "",
      "placeholder": "비밀번호를 재입력하세요."
    },
    model: {
      value: _vm.me.subPassword2,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "subPassword2", $$v);
      },
      expression: "me.subPassword2"
    }
  })], 1), _vm.isOrganization ? [_c('input-row', {
    attrs: {
      "label": "기업명",
      "pointer": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "companyName", $$v);
      },
      expression: "me.companyName"
    }
  })], 1), _c('input-row', {
    attrs: {
      "label": "대표자명",
      "pointer": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.ceoName,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "ceoName", $$v);
      },
      expression: "me.ceoName"
    }
  })], 1), _c('input-row', {
    attrs: {
      "label": "기업설립일",
      "pointer": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input",
    attrs: {
      "type": "date",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.establishedAt,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "establishedAt", $$v);
      },
      expression: "me.establishedAt"
    }
  })], 1), _c('input-row', {
    attrs: {
      "label": "사업자등록번호",
      "pointer": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.businessNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "businessNumber", $$v);
      },
      expression: "me.businessNumber"
    }
  })], 1)] : _vm._e(), _vm.isIndividual ? _c('input-row', {
    attrs: {
      "label": "이름",
      "pointer": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.name,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "name", $$v);
      },
      expression: "me.name"
    }
  })], 1) : _vm._e(), _vm.isSupporter ? _c('input-row', {
    attrs: {
      "label": "닉네임",
      "pointer": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.nickname,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "nickname", $$v);
      },
      expression: "me.nickname"
    }
  })], 1) : _vm._e(), _vm.isIndividual ? _c('input-row', {
    attrs: {
      "label": _vm.isSupporter ? '소속/부서' : '학교/학과',
      "pointer": ""
    }
  }, [_c('v-row', [_c('v-col', [_c('v-text-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.affiliation,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "affiliation", $$v);
      },
      expression: "me.affiliation"
    }
  })], 1), _c('v-col', {
    staticClass: "pl-0"
  }, [_c('v-text-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.department,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "department", $$v);
      },
      expression: "me.department"
    }
  })], 1)], 1)], 1) : _vm._e(), _c('input-row', {
    attrs: {
      "label": "연락처",
      "pointer": ""
    }
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-select', {
    attrs: {
      "items": ['010', '011', '016', '017', '019'],
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.phone1,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "phone1", $$v);
      },
      expression: "me.phone1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', {
    attrs: {
      "maxlength": "4",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.me.phone2 = _vm.me.phone2.replace(/[^0-9]/g, '');
      }
    },
    model: {
      value: _vm.me.phone2,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "phone2", $$v);
      },
      expression: "me.phone2"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', {
    attrs: {
      "maxlength": "4",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.me.phone2 = _vm.me.phone2.replace(/[^0-9]/g, '');
      }
    },
    model: {
      value: _vm.me.phone3,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "phone3", $$v);
      },
      expression: "me.phone3"
    }
  })], 1)], 1)], 1), _c('input-row', {
    attrs: {
      "label": "이메일",
      "pointer": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.email,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "email", $$v);
      },
      expression: "me.email"
    }
  })], 1), _c('input-row', {
    attrs: {
      "label": "주소",
      "pointer": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "sm": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "우편번호",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    },
    model: {
      value: _vm.me.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "postcode", $$v);
      },
      expression: "me.postcode"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto",
      "sm": "2"
    }
  }, [_c('v-btn', {
    staticClass: "w-100 h-100 input-btn",
    attrs: {
      "block": "",
      "elevation": "0",
      "dark": "",
      "color": "grey-dark"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    }
  }, [_c('span', [_vm._v("검색")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "기본 주소를 입력해주세요.",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    },
    model: {
      value: _vm.me.address1,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "address1", $$v);
      },
      expression: "me.address1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "placeholder": "상세 주소를 입력해주세요.",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "address2", $$v);
      },
      expression: "me.address2"
    }
  })], 1)], 1)], 1), _c('myinfo-areas', {
    attrs: {
      "areas": _vm.areas
    },
    model: {
      value: _vm.me,
      callback: function callback($$v) {
        _vm.me = $$v;
      },
      expression: "me"
    }
  }), _vm.isOrganization ? [_c('input-row', {
    attrs: {
      "label": "홈페이지주소"
    }
  }, [_c('v-text-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.website,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "website", $$v);
      },
      expression: "me.website"
    }
  })], 1), _c('input-row', {
    attrs: {
      "label": "담당자정보"
    }
  }, [_c('v-row', [_c('v-col', [_c('v-text-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "label": "이름",
      "persistent-placeholder": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.workerName,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "workerName", $$v);
      },
      expression: "me.workerName"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "label": "직책",
      "persistent-placeholder": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.workerTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "workerTitle", $$v);
      },
      expression: "me.workerTitle"
    }
  })], 1)], 1)], 1), _c('input-row', {
    attrs: {
      "label": "주요생산제품"
    }
  }, [_c('v-text-field', {
    staticClass: "input rounded-0",
    attrs: {
      "type": "text",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.me.mainProduct,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "mainProduct", $$v);
      },
      expression: "me.mainProduct"
    }
  })], 1), _c('input-row', {
    attrs: {
      "label": "기업개요"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.me.summary,
      expression: "me.summary"
    }],
    staticClass: "input rounded-0",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.me.summary
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.me, "summary", $event.target.value);
      }
    }
  })]), _c('input-row', {
    attrs: {
      "label": "기업로고"
    }
  }, [_c('v-file-input', {
    staticClass: "rounded-0",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "accept": "image/*"
    },
    model: {
      value: _vm.me.avatar,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "avatar", $$v);
      },
      expression: "me.avatar"
    }
  })], 1), _c('form-files', {
    attrs: {
      "title": "소개자료"
    },
    model: {
      value: _vm.me.brochures,
      callback: function callback($$v) {
        _vm.$set(_vm.me, "brochures", $$v);
      },
      expression: "me.brochures"
    }
  })] : _vm._e()], 2)]), _c('div', {
    staticClass: "button-group"
  }, [_c('v-btn', {
    staticClass: "min-w-120px min-w-lg-200px",
    attrs: {
      "large": "",
      "outlined": "",
      "rounded": "",
      "color": "grey",
      "elevation": "0"
    }
  }, [_c('span', {
    staticClass: "color-grey"
  }, [_vm._v("취소")])]), _c('v-btn', {
    staticClass: "min-w-120px min-w-lg-200px",
    attrs: {
      "large": "",
      "rounded": "",
      "color": "primary",
      "elevation": "0"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v("저장")])])], 1)], 1)], 1) : _vm._e(), _c('daum-postcode', {
    ref: "daumPostcode",
    on: {
      "change": function change(_ref) {
        var postcode = _ref.postcode,
          address = _ref.address;
        return Object.assign(_vm.me, {
          postcode: postcode,
          address1: address
        });
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }